import { useEffect, useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import { rememberClaim } from "@/lib/claim";
import { Spinner } from "@/components/kit";

export default function FinishSignup() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const token = params.get("claim");
    if (!token) return setState("invalid");
    rememberClaim(token).then(() => setState("ok")).catch(() => setState("invalid"));
  }, [params]);

  if (state === "checking") return <Spinner className="min-h-screen items-center" />;
  if (state === "ok") return <Navigate to="/login?mode=register" replace />;
  return (
    <div className="min-h-screen flex items-center justify-center mm-gradient-soft px-5">
      <div className="mm-card p-10 max-w-md w-full text-center" data-testid="finish-signup-invalid">
        <XCircle className="mx-auto text-mm-error" size={48} />
        <h1 className="text-2xl font-bold mt-4">This link has already been used</h1>
        <p className="text-mm-muted mt-2">Your payment is already linked to an account. Log in to continue.</p>
        <Link to="/login" className="mm-btn mt-6" data-testid="finish-signup-login">Log in</Link>
      </div>
    </div>
  );
}
